import React from "react";
import { Col, Row } from "react-bootstrap";
import { Title } from "../title";
import "./style.scss";

export const UpperRow = ({ title, manyButtons = false, buttons, ...props }) => {
  return (
    <div className="ldsrf-upper-row-container">
      <Row className="ldsrf-upper-row">
        <Col
          className={`title-col ${
            manyButtons ? "small" : ""
          } text-left my-auto`}
        >
          <Title size="regular">{title ? title : ""}</Title>
        </Col>
        <Col className="buttons-col text-right my-auto">
          {buttons &&
            buttons.length > 0 &&
            buttons.map((button) => {
              return button;
            })}
        </Col>
      </Row>
    </div>
  );
};
